import { Component, OnInit } from '@angular/core';
import { Version } from '@util/variable';
@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  private thisYear: number = new Date().getFullYear();
  private version = Version.VERSION_ID
  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer/footer.component.ts